module.exports = __webpack_public_path__ + "sunsemweb/img/5.f07c8269.png";